<aside class="sagmenu">
    <h4 class="sagmenuTitle">GENEL BİLGİLER</h4>
    <div [innerHTML]="Icerik | htmlPipe"></div>
</aside>